import { normalizePageKey } from './legacyPageKeys';
import { AREA_LABEL } from '../data/areaLabels';

// Which area (category) a note belongs to. Notes are saved against the page
// they were written on, and several pages/object types roll up into one area.
const PAGE_TO_AREA = {
  identity: 'identity',
  'guest-users': 'identity',
  devices: 'devices',
  exchange: 'exchange',
  applications: 'applications',
  'intune-apps': 'applications',
  roles: 'roles',
  'conditional-access': 'conditional-access',
  security: 'security',
  sharepoint: 'sharepoint',
  groups: 'sharepoint',
  licenses: 'licenses',
};

export const AREA_ORDER = ['identity', 'devices', 'exchange', 'applications', 'roles', 'conditional-access', 'security', 'sharepoint', 'licenses'];

export function noteArea(note) {
  return PAGE_TO_AREA[normalizePageKey(note.page)] || null;
}

export function areaCategoryLabel(area) {
  return area ? AREA_LABEL[area] || area : 'Øvrige';
}
